import { DEVICE_ROLES } from '@/features/core/container';
import { MetricResolutionAggregator, MetricResolutionTimeSource, SpotRole } from '@/types/iot-portal';
import { option } from '@/util/container';
import { component } from '../component';
import lg from './individual-meter-heat-meter-counter-lg.svg';
import md from './individual-meter-heat-meter-counter-md.svg';
import sm from './individual-meter-heat-meter-counter-sm.svg';

export default option(DEVICE_ROLES, async () => ({
  name: SpotRole.INDIVIDUAL_METER_HEAT_METER_COUNTER,
  label: 'Individueller_Wärmemengenzähler',
  shortLabel: 'INDWZ',
  icons: { sm, md, lg },
  component: component('individual-meter-heat-meter-counter/IndividualMeterHeatMeterCounterDevicePanel.vue'),
  aggregationWidget: {
    enabled: true,
    component: component('individual-meter-heat-meter-counter/IndividualMeterHeatMeterCounterAggregationWidget.vue'),
  },
  defaultMetricNames: ['currentEnergy'],
  importantMetricNames: ['currentEnergy', 'currentFlow', 'currentVolume'],
  consumption: true,
  aggregationMetricNames: [
    {
      name: 'currentEnergy',
      aggregators: [MetricResolutionAggregator.MEAN],
      timeSource: MetricResolutionTimeSource.START,
    },
    {
      name: 'currentFlow',
      aggregators: [MetricResolutionAggregator.MEAN],
      timeSource: MetricResolutionTimeSource.START,
    },
  ],
}));
